import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import { I18nProvider } from "@/i18n";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Products from "@/components/site/Products";
import Brands from "@/components/site/Brands";
import WhyUs from "@/components/site/WhyUs";
import Process from "@/components/site/Process";
import CTAInquiry from "@/components/site/CTAInquiry";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

function useReveal() {
  useEffect(() => {
    const els = document.querySelectorAll(".reveal");
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);
}

const Home = () => {
  useReveal();
  return (
    <main data-testid="home-page" className="relative overflow-hidden">
      <Header />
      <Hero />
      <About />
      <Products />
      <Brands />
      <WhyUs />
      <Process />
      <CTAInquiry />
      <Contact />
      <Footer />
    </main>
  );
};

function App() {
  return (
    <div className="App">
      <I18nProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          theme="dark"
          position="top-right"
          toastOptions={{
            style: {
              background: "rgba(10,10,15,0.85)",
              border: "1px solid rgba(255,255,255,0.12)",
              color: "#fff",
              backdropFilter: "blur(20px)",
            },
          }}
        />
      </I18nProvider>
    </div>
  );
}

export default App;
